import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

export const exportLivroRazaoExcel = (contas) => {
  if (!Array.isArray(contas) || contas.length === 0) {
    alert("Não há dados para exportar.");
    return;
  }

  const rows = [];

  contas.forEach((conta) => {
    // Cabeçalho por conta
    rows.push({
      Conta: `${conta.codigo} - ${conta.nome}`,
      Data: "",
      Histórico: "",
      Débito: "",
      Crédito: "",
      "Saldo Corrente": "",
    });

    // Saldo anterior
    rows.push({
      Conta: "",
      Data: "",
      Histórico: "Saldo Anterior",
      Débito: "",
      Crédito: "",
      "Saldo Corrente": conta.saldoAnterior,
    });

    // Lançamentos
    conta.lancamentos.forEach((l) => {
      rows.push({
        Conta: "",
        Data: dayjs(l.dataReferencia).format("DD/MM/YYYY"),
        Histórico: l.nome,
        Débito: l.valorDebito || 0,
        Crédito: l.valorCredito || 0,
        "Saldo Corrente": l.saldoAcumulado,
      });
    });

    // Saldo final
    rows.push({
      Conta: "",
      Data: "",
      Histórico: "Saldo Final",
      Débito: conta.debitos,
      Crédito: conta.creditos,
      "Saldo Corrente": conta.saldoFinal,
    });

    // Linha em branco entre contas
    rows.push({});
  });

  const worksheet = XLSX.utils.json_to_sheet(rows);

  // Ajuste automático de largura
  worksheet["!cols"] = [
    { wch: 30 },
    { wch: 12 },
    { wch: 40 },
    { wch: 15 },
    { wch: 15 },
    { wch: 18 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Livro Razão");

  const buffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "livro-razao.xlsx");
};

export const exportLancamentosExcel = (lancamentos) => {
  if (!Array.isArray(lancamentos) || lancamentos.length === 0) {
    alert("Não há dados para exportar.");
    return;
  }

  const consolidated = {};

  lancamentos.forEach((l) => {
    // Agrupamento por ID ou Signature (Data, Nome e Valor)
    const dataKey = l.dataReferencia ? dayjs(l.dataReferencia).format("YYYYMMDD") : "SD";
    const valorKey = Number(l.valor || l.valorDebito || l.valorCredito || 0).toFixed(2);
    const nomeKey = (l.nome || l.descricao || "").trim().toUpperCase();
    const id = l.id || `GRP-${dataKey}-${nomeKey}-${valorKey}`;

    if (!consolidated[id]) {
      consolidated[id] = {
        data: l.dataReferencia,
        nome: l.nome || l.descricao,
        valor: l.valor || Math.max(Number(l.valorDebito || 0), Number(l.valorCredito || 0)),
        debitos: new Set(),
        creditos: new Set(),
      };
    }

    const t = consolidated[id];
    const codDeb = l.contaContabilDebito?.codigo;
    const codCred = l.contaContabilCredito?.codigo;
    const vDeb = Number(l.valorDebito || 0);
    const vCred = Number(l.valorCredito || 0);

    // Identifica o Código Reduzido e insere no lado correto
    if (codDeb && codCred) {
      t.debitos.add(codDeb);
      t.creditos.add(codCred);
    } else if (vDeb > 0) {
      // Se há valor de débito, a conta disponível é tratada como débito
      const cod = codDeb || codCred;
      if (cod) t.debitos.add(cod);
    } else if (vCred > 0) {
      // Se há valor de crédito, a conta disponível é tratada como crédito
      const cod = codCred || codDeb;
      if (cod) t.creditos.add(cod);
    } else {
      if (codDeb) t.debitos.add(codDeb);
      if (codCred) t.creditos.add(codCred);
    }
  });

  const rows = Object.values(consolidated).map((t) => ({
    Data: t.data ? dayjs(t.data).format("DD/MM/YYYY") : "",
    "Nome Lançamento": t.nome || "",
    Valor: Number(t.valor) || 0,
    "Cód. Red. Débito": Array.from(t.debitos).sort().join(", "),
    "Cód. Red. Crédito": Array.from(t.creditos).sort().join(", "),
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);

  // Ajuste automático de largura
  worksheet["!cols"] = [
    { wch: 15 }, // Data
    { wch: 40 }, // Nome Lançamento
    { wch: 15 }, // Valor
    { wch: 20 }, // Cód. Red. Débito
    { wch: 20 }, // Cód. Red. Crédito
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Lançamentos");

  const buffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "lancamentos.xlsx");
};
